import styled from 'styled-components'

import Icon from '../Icon'

const Container = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  color: var(--Grays-Black, #07091e);
  font-family: Rubik;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`

export const Slogan = () => {
  return (
    <Container>
      <Icon type="logo" />
      <span style={{ marginLeft: -5 }}>Creavo</span>
    </Container>
  )
}
